<template>
  <div class="submitToView">
  
    <main>
      <header>
        <img :src="submitSuccess" alt="" srcset="" />
        <div class="title">{{ $t('vulnerability.submissionZH') }}</div>
        <div class="title">{{ $t('vulnerability.submissionEN') }}</div>
      </header>
      <section>
       <div class="sent text">
         {{ $t('vulnerability.sent') }} 
       </div>
       <div class="text">
        <span>①</span>
        <div>{{ $t('vulnerability.emailAdd') }}</div>
       </div>
       <div class="text">
        <span>②</span>
        <div>{{ $t('vulnerability.mailbox') }}</div>
       </div>
      
      </section>
      <footer>
        <div style="width: 100%;">
          <el-button class="submit" size="small" type="primary" @click="goDisclosure">{{$t('vulnerability.disclosure')}}</el-button>
        </div>
       
        <el-button class="submit" size="small" @click="back">{{$t('vulnerability.return')}}</el-button>
       </footer>
    </main>
  </div>
</template>

<script>
import router from '@/router';

export default {
  name: 'submitSuc',

  data() {
    return {
      bgIMG: require('../assets/headerBg.png'),
      submitSuccess: require('../assets/submitSuccess.png'),
       
      };
    },
  methods: {
    goDisclosure () {
      this.$router.push({
        path:'/vulnerability-show'
      })
    },
    back () {
      this.$emit('back',false)
    }
  }
}
</script>
<style lang="less" scoped>
.submitToView {
  width: 100%;
  height: 100%;
  position: relative;
  .headerBg {
    width: 100%;
    position: absolute;
    z-index: -1;
    .bg {
      width: 100%;
    }
  }
  main {
    width: 100%;
    height: 100%;
    header {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 24px 0 8px;
      img {
        width: 80px;
        height: 80px;
      }
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        line-height: 25px;
      }
    }
    section {
      padding: 0 15px;
      margin: auto;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0,0,0,0.6);
      line-height: 28px;
      .text {
        display: flex;
        white-space: pre-line;
        span {
          margin-right: 10px;
        }
      }
    }
    footer {
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 24px;
      .submit{
        width: 100%;
        height: 48px;
        font-size: 18px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
